import { render, staticRenderFns } from "./EditRelateDevice.vue?vue&type=template&id=fc038856&scoped=true&"
import script from "./EditRelateDevice.vue?vue&type=script&lang=js&"
export * from "./EditRelateDevice.vue?vue&type=script&lang=js&"
import style0 from "./EditRelateDevice.vue?vue&type=style&index=0&id=fc038856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc038856",
  null
  
)

export default component.exports